import { Avatar, Button, Flex, Modal, Paragraph } from 'ui'
import { BlockModalProps, BlockModalType } from './types'

type Props = BlockModalProps & {
  worker: {
    id: number
    name?: string
    profilePicUrl?: string
  }
}

export function NewWorker(props: Props) {
  const { isOpen, onClose, onNext, worker } = props

  return (
    <Modal
      title={`Are you sure you want to block this new worker${
        worker.name ? `, ${worker.name}` : ''
      }?`}
      open={isOpen}
      onClose={() => onClose()}
      customCta={
        <>
          <Button
            variant={'text'}
            onClick={() => onNext(BlockModalType.FillRate)}
          >
            Block Worker
          </Button>
          <Button onClick={() => onNext(BlockModalType.Feedback)}>
            Give Feedback
          </Button>
        </>
      }
    >
      <Flex justifyContent={'center'}>
        <Avatar
          user={{
            userId: worker.id.toString(),
            name: worker.name,
            photoUrl: worker.profilePicUrl,
          }}
          size={'xxlarge'}
        />
      </Flex>
      <Paragraph>
        It's {worker.name ? `${worker.name}'s` : "this worker's"} first time
        working for you. We recommend providing them with{' '}
        <strong>feedback</strong> and giving them another chance.
      </Paragraph>
    </Modal>
  )
}
